<template>
  <div>
    <div id="countHolder">
      <div id="countColumn1">
        <p v-for="i in 10" :key="i">
          {{ i - 1 }}
        </p>
      </div>
      <div id="countColumn2">
        <p v-for="i in 10" :key="i">
          {{ i - 1 }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Counter',
  props: {
    currentProject: Object
  },
  watch: {
    currentProject(value) {
      this.updateCount(value.id)
    },
  },
  data(){
    return {
      countColumn1: null,
      countColumn2: null,
      storeId: '01'
    }
  },
  methods:{
    updateCount(id){
      this.storeId = id
      let index1 = Number(id[0])
      let index2 = Number(id[1])
      
      this.countColumn1.style.transform = `translateY(-${index1 * 100}%)`
      this.countColumn2.style.transform = `translateY(-${index2 * 100}%)`
    },
  },
  mounted(){
    this.countColumn1 = document.getElementById('countColumn1')
    this.countColumn2 = document.getElementById('countColumn2')

    this.updateCount(this.storeId)
  }
}
</script>

<style scoped>
/* Count */
#countHolder
{
  display: flex;
  flex-direction: row;

  overflow: hidden;
}
#countColumn1,
#countColumn2
{
  transition-duration: 500ms;
  transition-timing-function: ease-in-out;
}
#countColumn1 p,
#countColumn2 p
{
  width: min-content;

  margin: 0;
}
@media screen and (orientation: landscape) {
  /* Counter */
  #countHolder
  {
    height: 10vh;
    margin: -1vh 0;
  }
  #countColumn1 p,
  #countColumn2 p
  {
    font-size: 10vh;
    line-height: 10vh;
    height: 10vh;
  }
}
@media screen and (orientation : portrait) {
  /* Counter */
  #countHolder
  {
    height: 20vw;
    margin: -2vw 0;
  }
  #countColumn1 p,
  #countColumn2 p
  {
    font-size: 20vw;
    line-height: 20vw;
    height: 20vw;
  }
}
</style>